import { useMemo } from 'react'
// material-ui
import { Tooltip, Grid, Stack, Typography, useTheme, Box } from '@mui/material'
import { InfoCircleOutlined } from '@ant-design/icons'

// ==============================|| Label ||============================== //

const createStyles = (theme, italic) => ({
  text: {
    fontStyle: italic ? 'italic' : '',
  },
  required: {
    marginRight: '6px',
  },
})

const Label = ({
  italic = false,
  width,
  text,
  textSx,
  children,
  required = false,
  inline = false,
  placeOnRight = false,
  endLabel,
  tooltip,
  tooltipIcon = <InfoCircleOutlined />,
  color,
  px,
  py,
  variant = 'h6',
}) => {
  const theme = useTheme()
  const styles = createStyles(theme, italic)

  const finalColor = useMemo(() => {
    return color ?? theme.palette.text.secondary
  }, [color, theme.palette.text.secondary])

  return (
    <Grid container rowSpacing={1} alignItems={'center'} width={width}>
      <Grid item xs={inline ? undefined : 12}>
        <Stack
          direction="row"
          justifyContent={'space-between'}
          alignItems={'center'}
          px={px}
          py={py}
        >
          <Stack direction="row" columnGap={0.25}>
            {text && (
              <Typography color={finalColor} sx={{ ...styles.text, ...textSx }} variant={variant}>
                {text}&nbsp;
              </Typography>
            )}
            {required && (
              <Typography sx={styles.required} variant={variant} color={theme.palette.error.main}>
                *
              </Typography>
            )}
            {tooltip && (
              <Tooltip variant={variant} title={tooltip} placement="right">
                <Typography
                  sx={{ lineHeight: 'normal', marginTop: '3px' }}
                  variant="h6"
                  color={theme.palette.text.disabled}
                  alignSelf={'center'}
                >
                  <Box paddingBottom={'10%'}>{tooltipIcon}</Box>
                </Typography>
              </Tooltip>
            )}
          </Stack>
          {endLabel}
        </Stack>
      </Grid>
      {children && (
        <Grid item xs={inline ? undefined : 12} order={placeOnRight && -1}>
          {children}
        </Grid>
      )}
    </Grid>
  )
}

export default Label
